import { useEffect, useState } from "react";

const useFoods = () => {
    const [foods,setfoods]=useState([]);
    useEffect(()=>{
        fetch('https://organic-food-server.up.railway.app/foods')
        .then(res=>res.json())
        .then(data=>setfoods(data));
    },[]);
    return [foods,setfoods];
};

export default useFoods;